var moment = require('moment');

export const groupDatesByRoom = (availableDates) => {
  if (!availableDates || !Array.isArray(availableDates)) {
    return {};
  }

  const grouped = {};

  availableDates.forEach((item) => {
    if (!item || item.roomId === undefined || item.roomId === null) {
      return;
    }

    if (!grouped[item.roomId]) {
      grouped[item.roomId] = {
        roomName: item.roomName || 'Unknown Room',
        dates: []
      };
    }
    grouped[item.roomId].dates.push(item);
  });

  Object.keys(grouped).forEach((roomId) => {
    grouped[roomId].dates.sort((a, b) => new Date(a.date) - new Date(b.date));
  });

  return grouped;
};

export const getSortedRoomIds = (groupedDates) => {
  if (!groupedDates || typeof groupedDates !== 'object') {
    return [];
  }

  return Object.keys(groupedDates).sort((a, b) => {
    const nameA = (groupedDates[a]?.roomName || '').toLowerCase();
    const nameB = (groupedDates[b]?.roomName || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });
};

export const formatClipboardText = (availableDates, options = {}) => {
  if (!availableDates || availableDates.length === 0) {
    return '';
  }

  const { hideHoldPositions = false } = options;
  const grouped = groupDatesByRoom(availableDates);
  const sortedRoomIds = getSortedRoomIds(grouped);

  if (sortedRoomIds.length === 0) {
    return '';
  }

  const roomText = sortedRoomIds.map((roomId) => {
    const room = grouped[roomId];
    if (room.dates.length === 0) {
      return `${room.roomName}:\nNo available dates`;
    }
    const dateLines = room.dates
      .map((d) => {
        const dateStr = moment(d.date).format('dddd, MMMM D, YYYY');
        if (hideHoldPositions) {
          return dateStr;
        }
        const positionStr = d.position != null ? `H${d.position}` : '(all positions taken)';
        return `${positionStr} - ${dateStr}`;
      })
      .join('\n');
    return `${room.roomName}\n${dateLines}`;
  }).join('\n\n');

  return `Dates not listed are N/A\n\n${roomText}`;
};

export const roomOptions = (rooms) => {
  return rooms.map((room) => ({ value: room.id, label: room.name }));
};

export const resolveCheckAvailsRooms = (selectedRooms, rooms, roomId) => {
  if (roomId == null) {
    return selectedRooms;
  }

  return roomOptions(rooms.filter((room) => room.id === roomId));
};

export const getAvailableDatesCount = (availableDates) => {
  if (!availableDates || !Array.isArray(availableDates)) {
    return 0;
  }
  return availableDates.length;
};
